import React from 'react';
import CreateFeedback from '../../CreateFeedback/PostFeedback';

const FeedbackButton = () => {



return(
    <CreateFeedback/>

)
}

export default FeedbackButton